import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// tools
import formatDateString from '../../helpers/formatDateString';
import parseDateValue from '../../helpers/parseDateValue';
import { deadlineRules, disablePastDates } from '../../helpers/deadlineField';

// store
import { storeSet } from '../../store';

// components
import ModalDialog from '../ModalDialog';
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';

/**
 * Edit a single field of a project (rename / change due date) from the project
 * card context menu. Uses PATCH /projects/{id}, so only the changed field is
 * sent — no multipart body, no resending the untouched fields.
 */
const ModalEditProjectField = ({ project, field, visible, onHide }) => {
    const isDeadline = 'deadline' === field;
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { isValid },
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            title: project.title || '',
            deadline: parseDateValue(project.deadline)
        }
    });

    useEffect(() => {
        reset({
            title: project.title || '',
            deadline: parseDateValue(project.deadline)
        });
    }, [project, visible, reset]);

    const onSubmit = async (formData) => {
        const body = isDeadline
            ? { deadline: formatDateString(formData.deadline) }
            : { title: formData.title };

        setLoading(true);

        try {
            await storeSet('patchProject', project.id, body);
            onHide();
        } catch (error) {
            // Error already displayed by the store action
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        reset();
        onHide();
    };

    return (
        <ModalDialog
            additionalClasses={['modalEditProjectField']}
            header={isDeadline
                ? __('Modifica la scadenza', 'soundbetween')
                : __('Rinomina il progetto', 'soundbetween')}
            visible={visible}
            onSubmit={handleSubmit(onSubmit)}
            onHide={handleCloseModal}
            width={420}>
            <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                <fieldset>
                    {isDeadline
                        ? <FormField
                            type="datepicker"
                            name="deadline"
                            label={__('Deadline', 'soundbetween')}
                            control={control}
                            rules={deadlineRules}
                            shouldDisableDate={disablePastDates}
                        />
                        : <FormField
                            type="text"
                            name="title"
                            label={__('Titolo', 'soundbetween')}
                            placeholder={__('Digita nome progetto', 'soundbetween')}
                            control={control}
                            rules={{ required: __('È obbligatorio', 'soundbetween') }}
                        />}

                    <div className="appFormActions">
                        <ButtonFlat size="lg" onClick={(e) => { e.preventDefault(); handleCloseModal(); }}>
                            {__('Annulla', 'soundbetween')}
                        </ButtonFlat>
                        <ButtonFormSubmit disabled={loading || !isValid}>
                            {__('Salva', 'soundbetween')}
                        </ButtonFormSubmit>
                    </div>
                </fieldset>
            </form>
        </ModalDialog>
    )
}

export default ModalEditProjectField;
